<template>
  <div class="slider">
    <div class="slide-wrapper">
      <transition-group
        name="slide"
        mode="out-in"
        enter-class="slide-in"
        leave-class="slide-out"
        enter-active-class="animated slide-in-active"
        leave-active-class="animated slide-out-active"
        v-on:after-enter="afterEnter"
        v-on:before-leave="beforeLeave"
      >
        <template v-for="(slide, index) in slides">
          <div class="slide" :key="`slide-${index}`" v-if="index == (currentSlide - 1)">
            <div class="slide-image" :style="setCover(slide.file_url)"></div>
          </div>
        </template>
      </transition-group>
    </div>

    <div class="slider-nav" v-if="slidesCount > 1">
      <span class="slide-prev" @click="slide(-1)"></span>
      <div class="slider-dots">
        <a
          href="#"
          v-for="(dot, index) in slidesCount"
          :key="`jump-to-${index}`"
          :class="{ 'active': ++index === currentSlide }"
          @click.prevent="jump(index)"
        ></a>
      </div>
      <span class="slide-next" @click="slide(1)"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      slides: [],
      slidesCount: 0,
      currentSlide: 1,
      inTransition: false
    };
  },

  mounted() {
    this.slides = this.items;
    this.slidesCount = this.slides.length;
  },

  methods: {
    slide(amount) {
      let newActive;
      const newIndex = this.currentSlide + amount;

      if (this.inTransition === false) {
        if (newIndex > this.slidesCount) newActive = 1;
        if (newIndex === 0) newActive = this.slidesCount;

        this.currentSlide = newActive || newIndex;
      }
    },

    jump(index) {
      if (this.inTransition === false) {
        this.currentSlide = index;
      }
    },

    afterEnter(el) {
      this.inTransition = false;
    },

    beforeLeave(el) {
      this.inTransition = true;
    },

    setCover(img) {
      return "background-image: url(" + img + ")";
    }
  }
};
</script>
